import React, { useState, useMemo, useEffect } from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { MdTune } from 'react-icons/md';
import { FiLogOut, FiTrash2 } from 'react-icons/fi';
import { FaRegImage } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import CommonMenu from './CommonMenu';
import AddPostcardModal from '../Modals/AddPostcardModal';  // Импортируем новое модальное окно
import LanguageFilter from '../Common/LanguageFilter';

const ChannelOptionsMenu = ({ isOpen, onSelect, onClose, openEditModal, userId, ownerId, selectedLanguage, onLanguageChange }) => {
    const { t } = useTranslation();
    const [isAddPostcardModalOpen, setAddPostcardModalOpen] = useState(false); // Состояние для модального окна

    // Динамический label для пункта "Добавить открытку"
    const addPostcardLabel = useMemo(() => {
        let label = t("UI.ChannelOptionsMenu.addPostcard");
        if (typeof window !== 'undefined' && window.innerWidth > 640) {
            label += ' (Ins)';
        }
        return label;
    }, [t]);

    // Динамический label для пункта "Описание канала"
    const channelDescriptionLabel = useMemo(() => {
        let label = t("UI.ChannelOptionsMenu.channelDescription");
        if (typeof window !== 'undefined' && window.innerWidth > 640) {
            label += ' (i)';
        }
        return label;
    }, [t]);

    // Глобальный обработчик клавиши 'i'/'ш' для открытия описания канала
    useEffect(() => {
        if (!isOpen) return;
        const handleKeyDown = (e) => {
            if (window.innerWidth > 640) {
                if (e.key === 'i' || e.key === 'ш') {
                    onSelect && onSelect('channelDescription');
                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, onSelect]);

    if (!isOpen) return null;

    const items = [
        // Фильтр по языку для мобильной версии (скрываем на десктопе)
        {
            id: 'languageFilter',
            label: '🌍 Фильтр по языку',
            icon: <span className="text-lg">🌍</span>,
            isCustom: true,
            customContent: (
                <div className="px-4 py-2 border-b border-gray-200 dark:border-gray-700 md:hidden">
                    <LanguageFilter
                        selectedLanguage={selectedLanguage}
                        onLanguageChange={onLanguageChange}
                        size="sm"
                        className="w-full"
                    />
                </div>
            )
        },
        {
            id: 'addPostcard',
            label: addPostcardLabel,
            icon: <FaRegImage size={20} />,
            onClick: () => {
                onSelect("addPostcard");
            }
        },
        {
            id: 'channelDescription',
            label: channelDescriptionLabel,
            icon: <AiOutlineInfoCircle size={20} />,
            onClick: () => onSelect("channelDescription")
        },
        {
            id: 'channelManagement',
            label: t("UI.ChannelOptionsMenu.channelManagement"),
            icon: <MdTune size={20} />,
            onClick: () => {
                onSelect("channelManagement");
                onClose();
                openEditModal();
            }
        },
        userId && ownerId && String(userId) === String(ownerId)
            ? {
                id: 'deleteChannel',
                label: t("UI.ChannelOptionsMenu.deleteChannel") || 'Удалить канал',
                icon: <FiTrash2 size={20} />,
                className: "text-red-500",
                onClick: () => onSelect("deleteChannel")
            }
            : {
                id: 'leaveChannel',
                label: t("UI.ChannelOptionsMenu.leaveChannel"),
                icon: <FiLogOut size={20} />,
                className: "text-red-500",
                onClick: () => onSelect("leaveChannel")
            }
    ];

    return (
        <>
            <CommonMenu onClose={onClose} items={items} />
            <AddPostcardModal
                isOpen={isAddPostcardModalOpen}
                onClose={() => setAddPostcardModalOpen(false)}
            />
        </>
    );
};

export default ChannelOptionsMenu;
